// import {Form, useEditContext, useResourceContext} from 'ra-core';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {useMutation} from '@tanstack/react-query';
import {postRequest} from '@/lib/client';
import TextInput from '@/components/refinedev/TextInput';
import useDialogState from 'hooks/useDialogState';
import {Button} from '@/shadcn_components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from '@/shadcn_components/ui/dialog';
import Spinner from '@/components/basic/Spinner';
import {BaseID} from '@/hooks/types';
import {FormProvider, useForm} from 'react-hook-form';
import { defaultMutationOptions } from '../_utils';

const schema = {
  username: yup.string().nullable().required('Cần nhập tên đăng nhập'),
  password: yup
    .string()
    .nullable()
    .required('Cần nhập mật khẩu')
    .min(6, 'Mật khẩu ít nhất 6 ký tự'),
  // .min(4, 'Password length should be at least 4 characters')
  // .max(12, 'Password cannot exceed more than 12 characters'),
  password_confirmation: yup
    .string()
    .nullable()
    .required('Cần xác nhận mật khẩu')
    .min(6, 'Mật khẩu ít nhất 6 ký tự')
    // .min(4, 'Password length should be at least 4 characters')
    // .max(12, 'Password cannot exceed more than 12 characters')
    .oneOf([yup.ref('password')], 'Mật khẩu không khớp'),
};

const createAccountResolver = yupResolver(yup.object().shape(schema).required());

type CreateAccountButtonProps = {
  resource: string; //resource like parents, staffs, students, ...
  id: BaseID; //id of the userable model
  usernamePrefix?: string; //prefix for username (as default value)
};

export const CreateAccountButton = (props: CreateAccountButtonProps) => {
  const {resource, id} = props;
  const {usernamePrefix = '_'} = props;
  // const context = useEditContext();
  const dialogState = useDialogState();
  const mutation = useMutation<any, any, any>({
    ...defaultMutationOptions,
    mutationFn: payload => postRequest(`/api/${resource}/createUser`, payload),
  });

  const useFormResults = useForm({
    defaultValues: {
      username: usernamePrefix + id,
      password: '',
      password_confirmation: '',
    },
    resolver: createAccountResolver,
  });

  async function createAccount(data) {
    try {
      const resp = await mutation.mutateAsync({
        id,
        ...data,
      });
      dialogState.closeDialog();
    } catch (err) {}
  }

  return (
    <>
      <Dialog open={dialogState.open} onOpenChange={dialogState.setOpen}>
        <DialogTrigger>
          <Button className="w-48" color="blue" type="button" onClick={dialogState.openDialog}>
            Tạo tài khoản
          </Button>
        </DialogTrigger>
        <DialogContent>
          <FormProvider {...useFormResults}>
            <form onSubmit={useFormResults.handleSubmit(createAccount)}>
              <DialogHeader>Tạo tài khoản đăng nhập</DialogHeader>

              <div className="max-w-xl flex flex-col gap-y-4">
                {/* <input hidden autoComplete="off" disabled name='lsdkjflasjdf'/> */}
                <TextInput source="username" label="Tên đăng nhập" />
                <TextInput source="password" label="Mật khẩu" type="password" />
                <TextInput
                  source="password_confirmation"
                  label="Xác nhận mật khẩu"
                  type="password"
                />
              </div>

              <DialogFooter>
                <Button
                  className="w-48"
                  color="blue"
                  type="submit"
                  // loading={mutation.isLoading}
                  disabled={mutation.isLoading}>
                  {mutation.isLoading && <Spinner />}
                  Tạo tài khoản
                </Button>
              </DialogFooter>
            </form>
          </FormProvider>
        </DialogContent>
      </Dialog>
    </>
  );
};

